import { formatINR } from '@print-saas/shared';

/** INR without the trailing ".00" for whole rupees — easier to read from a distance. */
export function formatPrice(paise: number): string {
  const s = formatINR(paise);
  return paise % 100 === 0 ? s.replace(/\.00$/, '') : s;
}

/** Short, human-readable reference for staff (last 6 chars of the session id). */
export function shortId(id: string): string {
  return id.replace(/[^a-zA-Z0-9]/g, '').slice(-6).toUpperCase();
}

export function plural(n: number, one: string, many = `${one}s`): string {
  return `${n} ${n === 1 ? one : many}`;
}

/** m:ss for a countdown; never negative. */
export function formatCountdown(ms: number): string {
  const total = Math.max(0, Math.ceil(ms / 1000));
  return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, '0')}`;
}
